import service from './request'
import uploadService from "./uploadRequest.js";

/**
 * 获取用户信息列表
 */
export const getUserList = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/user/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取用户信息
 */
export const getUserInfo = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/user/getInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 用户信息增加
 */
export const addUserInfo = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/user/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 用户信息修改
 */
export const updateUserInfo = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/user/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 用户密码修改
 */
export const updateUserPwd = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/user/updatePwd',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取用户权限列表
 */
export const getUserPowerList = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/user/getPowerList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取用户角色列表
 */
export const getRoleData = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/user/getRoleData',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 用户角色保存
 */
export const updateUserRoleData = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/user/updateRoleData',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 用户部门查看
 */
export const getOrgData = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/user/getOrgData',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 用户部门保存
 */
export const updateOrgData = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/user/updateOrgData',
        method: 'post',
        type: 'body',
        data
    })
}

//用户头像上传
export const uploadHeadImg = data => {
    return uploadService({
        url: window._CONFIG.impUpload_url||'/platform/user/uploadHeadImg',
        method: 'post',
        data
    })
};

//批量初始化信息赋值
export const batchSet = data => {
    return service({
        showLoading: true,
        url: '/cc/loginInit/batchSet',
        method: 'post',
        type: 'body',
        data
    })
};

//热线扩展信息赋值
export const userBatchSet = data => {
    return service({
        showLoading: true,
        url: '/cc/userAttributes/batchSet',
        method: 'post',
        type: 'body',
        data
    })
};

//获取用户扩展信息
export const userAttributesGetInfo = data => {
    return service({
        showLoading: true,
        url: '/cc/userAttributes/getInfo',
        method: 'post',
        data
    })
};

//保存用户扩展信息
export const userAttributesSaveInfo = data => {
    return service({
        showLoading: true,
        url: '/cc/userAttributes/saveInfo',
        method: 'post',
        type: 'body',
        data
    })
};

//获取电话坐席扩展信息
export const telagGetInfo = data => {
    return service({
        showLoading: true,
        url: '/cc/telag/getInfo',
        method: 'post',
        data
    })
};

//保存电话坐席扩展信息
export const telagSaveInfo = data => {
    return service({
        showLoading: true,
        url: '/cc/telag/saveInfo',
        method: 'post',
        type: 'body',
        data
    })
};



// WEBPACK FOOTER //
// ./src/http/UserManagement.js